import { createContext, useContext, useEffect, useState } from 'react';

const ToastContext = createContext();

let toastSetter = null;

export const setGlobalToast = (fn) => {
  toastSetter = fn;
};

export const showGlobalToast = (message) => {
  if (toastSetter) {
    toastSetter(message);
  }
};

export const ToastProvider = ({ children }) => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    setGlobalToast(setMessage);
  }, []);

  const clear = () => setMessage('');

  return <ToastContext.Provider value={{ message, show: setMessage, clear }}>{children}</ToastContext.Provider>;
};

export const useToast = () => useContext(ToastContext);
